<template>
  <div
    class="asc-data-sheet-wrapper--container"
    data-automation-id="wrapper_data_sheet"
  >
    <asc-data-sheet
      :items="getItems"
      :has-index="hasIndex"
      :has-filter="hasFilter"
    >
      <template slot="header">
        <asc-surface-title :title="getTitle"></asc-surface-title>
      </template>
      <template slot="filter">
        <asc-autocomplete-selector
          v-model="selectedItem"
          class="filter"
          label="ATA Chapter"
          :items="options"
          no-search-input
          no-tooltip
          no-array
        />
      </template>
    </asc-data-sheet>
  </div>
</template>

<script>
import AscSurfaceTitle from '@/components/atoms/AscSurfaceTitle'
import AscAutocompleteSelector from '@/components/molecules/AscAutocompleteSelector'
import AscDataSheet from '@/components/molecules/AscDataSheet'
import _ from 'lodash'

export default {
  name: 'AscDataSheetWrapper',

  components: {
    AscDataSheet,
    AscAutocompleteSelector,
    AscSurfaceTitle,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    hasIndex: {
      type: Boolean,
      default: true,
    },
    hasFilter: {
      type: Boolean,
      default: false,
    },
    dataId: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      filteredItems: [],
      selectedItem: this.dataId || null,
    }
  },

  computed: {
    options() {
      return this.items.map(item => ({
        text: item.text,
        value: item.id,
      }))
    },
    getItems() {
      const _that = this
      let filtered
      if (this.selectedItem) {
        filtered = _.find(this.items, item => {
          return item.id === _that.selectedItem
        })
      }

      return filtered ? filtered.messageDetail : null
    },
    getTitle() {
      return this.title ? this.title.toUpperCase() : ''
    },
  },

  watch: {
    dataId(newValue) {
      this.selectedItem = newValue
    },
  },
}
</script>

<style lang="scss">
.asc-data-sheet-wrapper--container {
  background-color: $primary-white;
  padding: 14px 16px;
  height: 272px;
}
</style>
